import Swiper, { Autoplay, Controller, EffectCreative, Navigation, Thumbs } from 'swiper'
import 'swiper/swiper-bundle.min.css'


document.addEventListener('DOMContentLoaded', () => {
  const history = document.querySelector('.history')
  if (history) {
    const progressbarItems = history.querySelectorAll('.history-progressbar__item')
    const historyProgress = history.querySelector('.history-progressbar')
    const navNext = history.querySelector('.history-progressbar__nav-next')
    const navPrev = history.querySelector('.history-progressbar__nav-prev')

    const historySwiperContent = new Swiper('.history-slider--content', {
      modules: [Navigation, EffectCreative, Autoplay, Controller],
      effect: "creative",
      speed: 1000,
      parallax: true,
      allowTouchMove: false,
      spaceBetween: 2,
      creativeEffect: {
        prev: {
          translate: ["-20%", 0, -1],
        },
        next: {
          translate: ["100%", 0, 0],
        },
      },
      breakpoints: {
        999: {
          loop: false,
          allowTouchMove: false
        },
        0: {
          loop: true,
          allowTouchMove: true
        }
      }
    });

    const historySwiper = new Swiper('.history-slider--image', {
      modules: [Navigation, EffectCreative, Autoplay, Thumbs, Controller],
      effect: "creative",
      speed: 1000,
      parallax: true,
      spaceBetween: 2,
      creativeEffect: {
        prev: {
          translate: ["-20%", 0, -1],
        },
        next: {
          translate: ["100%", 0, 0],
        },
      },
      breakpoints: {
        999: {
          loop: false,
          allowTouchMove: false
        },
        0: {
          loop: true,
          allowTouchMove: true
        }
      }
    });

    const scrollProgress = (index) => {
      if (window.innerWidth > 780) {
        historyProgress.scrollTo({ top: progressbarItems[index].offsetTop - 275 + 5, behavior: 'smooth' })
      } else {
        historyProgress.scrollTo({
          left: progressbarItems[index].offsetLeft - window.innerWidth / 2,
          behavior: 'smooth'
        })
      }
    }
    let slideChange
    let throttle = false


    const nextSlide = () => {
      if(historySwiper.realIndex === progressbarItems.length - 1) historySwiper.slideTo(0)
      else historySwiper.slideNext()
    }

    const startTimeout = () => {
      clearTimeout(slideChange)
      if (throttle) {
        slideChange = setTimeout(() => {
          throttle = false
          nextSlide()
        }, 30000)
      } else {
        slideChange = setTimeout(() => {
          nextSlide()
        }, 10000)
      }
    }


    historySwiper.on('touchMove', () => throttle = true)
    historySwiperContent.on('touchMove', () => throttle = true)

    navNext.addEventListener('click', () => {
      nextSlide()
      throttle = true
    })
    navPrev.addEventListener('click', () => {
      if(historySwiper.realIndex === 0) historySwiper.slideTo(progressbarItems.length - 1)
      else historySwiper.slidePrev()
      throttle = true
    })

    historySwiper.on('slideChange', (e) => {
      document.querySelector('.history-progressbar__item--active')?.classList.remove('history-progressbar__item--active')
      progressbarItems[historySwiper.realIndex].classList.add('history-progressbar__item--active')
      scrollProgress( historySwiper.realIndex )
      startTimeout()
    })


    historySwiper.controller.control = historySwiperContent;
    historySwiperContent.controller.control = historySwiper;


    progressbarItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        throttle = true
        startTimeout()
        historySwiper.slideTo( window.innerWidth > 999 ? index : index + 1)
      })
    })

    let start = false
    let timeoutScroll
    window.addEventListener('scroll', () => {
      if (!start) {
        clearTimeout(timeoutScroll)
        timeoutScroll = setTimeout(() => {
          if (history.offsetTop - history.clientHeight / 2 <= scrollY) {
            progressbarItems[0].classList.add('history-progressbar__item--active')
            startTimeout()
            start = true
          }
        }, 300)
      }
    })
  }

})